import type {ReactElement} from 'react';
import styles from './pending-reply-loader.module.scss';
import {PmwLogo} from '@Components/ai-chat-window/components/pmw-logo/pmw-logo';
import {CyclingLoadingText} from '@Components/ai-chat-window/components/cycling-loading-text/cycling-loading-text';
import type {PendingReplyLoaderProps} from './pending-reply-loader.types';

/**
 * The single loading row: an animated logo beside cycling text. Every path that waits on a reply
 * renders this — the live turn, a reload that lands mid-turn, and a reload that lands before any
 * of the reply was saved — so the row's spacing and type stay identical across all three. The
 * caller owns the row's outer spacing, since that depends on what sits above it.
 */
export function PendingReplyLoader({loadingTexts, turnStartedAt}: PendingReplyLoaderProps): ReactElement {
  return (
    <div className={styles.pendingReplyRow}>
      <PmwLogo className={styles.pendingReplyLogo} animated />
      <CyclingLoadingText loadingTexts={loadingTexts} turnStartedAt={turnStartedAt} />
    </div>
  );
}
